import React, { cloneElement, Component } from 'react';
import { connect } from 'react-redux';
import { goBack, push, replace } from 'react-router-redux'

import { addSubscription, resetBillingError } from '../../stores/billing/billing-actions';

class UpgradeContainer extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isProcessing: false,
    };

    if (props.user &&
        props.user.company &&
        props.user.company.plan.toLowerCase() !== 'basic'
      ) props.replace('/settings/billing');
  }

  componentWillMount() {
    const { dispatch } = this.props;
    dispatch(resetBillingError());
  }

  onClose = () => {
    if (window.history.length === 1) {
      this.props.push('/dashboard')
    } else {
      this.props.goBack();
    }
  }

  onUpgrade = (selectedPlan, response) => {
    const { dispatch } = this.props;
    dispatch(addSubscription(selectedPlan.planId, response.id, response.card))
    .then(() => {
      dispatch(resetBillingError());
      dispatch(push('/dashboard'));
    })
    .catch((err) => {
      console.log('onUpgrade Error', err);
    });
  }

  render() {
    const { children, ...props } = this.props;
    const extraProps = {
      stripePublicKey: process.env.STRIPE_PUBLIC_KEY,
      onClose: this.onClose,
      onUpgrade: this.onUpgrade,
      user: props.user,
      profile: props.profile,
      isProcessing: props.billing.isLoading,
      header: 'Upgrade to unlock the power of TourConnect',
      ...props,
    };

    return (
      <div>
        {children ? cloneElement(children, extraProps) : undefined}
      </div>
    );
  }
}

const mapStateToProps = (store) => {
  return (
    {
      billing: store.billing.toJS(),
      profile: store.profile.toJS(),
      user: store.user.toJS(),
      route: store.route,
    }
  );
};

export default connect(mapStateToProps, { goBack, push, replace })(UpgradeContainer);



// WEBPACK FOOTER //
// ./src/app/components/upgrade/upgrade-container.jsx